module.exports = __webpack_public_path__ + "static/img/duoyuan_yewan.f3720d85.png";